const IconArrowDashRight = (): JSX.Element => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0774 4.41076C11.4028 4.08533 11.9305 4.08533 12.2559 4.41076L17.2559 9.41076C17.5814 9.7362 17.5814 10.2638 17.2559 10.5893L12.2559 15.5893C11.9305 15.9147 11.4028 15.9147 11.0774 15.5893C10.752 15.2638 10.752 14.7362 11.0774 14.4108L14.6548 10.8334H3.33333C2.8731 10.8334 2.5 10.4603 2.5 10C2.5 9.53978 2.8731 9.16669 3.33333 9.16669H14.6548L11.0774 5.58928C10.752 5.26384 10.752 4.7362 11.0774 4.41076Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconArrowDashRight;
